import React, { Component } from "react";
import { get as _get } from "lodash";

import ReportHeader  from "./components/ReportHeader";
import TabNav        from "./components/TabNav";
import DashboardView from "./components/DashboardView";
import VisualsView   from "./components/VisualsView";
import BattlecardsView from "./components/BattlecardsView";
import AnalysisView  from "./components/AnalysisView";

class Template1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "dashboard",
    };
  }

  _handleTabChange = (tabId) => {
    this.setState({ activeTab: tabId });
  };

  _renderActiveTab = () => {
    const { activeTab } = this.state;
    const { reportData } = this.props;

    switch (activeTab) {
      case "dashboard":
        return <DashboardView reportData={reportData} />;
      case "visuals":
        return <VisualsView reportData={reportData} />;
      case "battlecards":
        return <BattlecardsView reportData={reportData} />;
      case "analysis":
        return <AnalysisView reportData={reportData} />;
      default:
        return <DashboardView reportData={reportData} />;
    }
  };

  render() {
    const { activeTab } = this.state;
    const { reportData } = this.props;

    return (
      <div className="sa-report-wrapper">
        <ReportHeader reportData={reportData} />
        <TabNav activeTab={activeTab} onTabChange={this._handleTabChange} />
        {this._renderActiveTab()}
      </div>
    );
  }
}

export default Template1;
